import { Group, Stack, Text, Title } from "@mantine/core"
import React from "react"

import classes from "~/assets/css/Global.module.css"

type Props = {
  title: string
  description?: string
  children: React.ReactNode
}

export function SettingsRow({ title, description, children }: Props) {
  return (
    <Group
      w="100%"
      className={classes.settings}
      align="start"
      py="var(--tfg-organism-padding-y)"
      justify="space-between"
    >
      <Stack gap="xs">
        <Title order={5}>{title}</Title>
        <Text>{description}</Text>
      </Stack>
      <Group justify="flex-end" w="50%">
        {children}
      </Group>
      <Stack />
    </Group>
  )
}
